import React from 'react';
import { generatePath, Link as RouterLink } from 'react-router-dom';
import { useFeature } from 'flagged';
import Avatar from '@/components/common/Avatar';
import ConstituentType from '@/constants/ConstituentType';
import AuthRoutes from '@/constants/routing/AuthRoutes';
import FeatureFlags from '@/constants/system/FeatureFlags';
import translate from '@/lib/intl/translate';
import type SearchConstituent from '@/types/api/SearchConstituent';
import getInitials from '@/utils/getInitials';

function ConstituentAvatar({
  constituent,
  hideAvatar = false,
}: {
  constituent: SearchConstituent;
  hideAvatar?: boolean;
}) {
  const hasIsDeceased = useFeature(FeatureFlags.IS_DECEASED);

  const initials = React.useMemo(
    () =>
      getInitials(
        constituent.displayName,
        constituent.constituentType === ConstituentType.PERSON,
      ),
    [constituent],
  );

  return (
    <div className="flex items-center gap-2">
      {!hideAvatar && <Avatar src={constituent.avatar}>{initials}</Avatar>}
      <div>
        <RouterLink
          to={generatePath(AuthRoutes.CONSTITUENT, {
            constituentId: constituent.constituentId,
          })}
        >
          <div className="inline text-tertiary-main type-h3 md:type-body2">
            {constituent.displayName}
          </div>
        </RouterLink>
        {hasIsDeceased &&
          constituent.constituentType === ConstituentType.PERSON &&
          constituent.isDeceased && (
            <span className="ml-1 text-text-secondary">
              ({translate('DECEASED_LABEL')})
            </span>
          )}
      </div>
    </div>
  );
}

export default ConstituentAvatar;
